import type { ReviewAgent, ReviewPlanner } from "./agent.js";
import { ClaudeCodeAgent } from "./claude.js";
import type { PlannerAgentConfig, ReviewerAgentConfig } from "./config.js";
import { ClaudeCodePlanner } from "./planner.js";

export function createReviewAgent(config: ReviewerAgentConfig): ReviewAgent {
  switch (config.adapter) {
    case "claude-code":
      return new ClaudeCodeAgent({ executable: config.executable, model: config.model });
  }
}

export function createReviewPlanner(config: PlannerAgentConfig): ReviewPlanner {
  switch (config.adapter) {
    case "claude-code":
      return new ClaudeCodePlanner({
        executable: config.executable,
        model: config.model,
        prompt: config.prompt,
      });
  }
}
